import { SupportLogo } from '@/widgets/Header/SupportLogo';
import { cn } from '@/shared/lib/cn';
import type { BootStep, BootStepState } from './useAppBoot';
import styles from './AppBootScreen.module.css';

const FILL: Record<BootStepState, string | undefined> = {
  pending: undefined,
  active: styles.fillActive,
  done: styles.fillDone,
  fail: styles.fillFail,
  skip: styles.fillSkip,
};

function caption(steps: BootStep[]): string {
  const active = steps.find((s) => s.state === 'active');
  if (active) return active.label;
  return steps.some((s) => s.state === 'fail') ? 'Соединение не установлено' : 'Готово';
}

export const AppBootScreen: React.FC<{ steps: BootStep[] }> = ({ steps }) => {
  const done = steps.filter((s) => s.state !== 'pending' && s.state !== 'active').length;
  const text = caption(steps);

  return (
    <div className={styles.root} role="status" aria-live="polite">
      <div className={styles.stage}>
        <SupportLogo className={styles.logo} />

        <div
          className={styles.track}
          role="progressbar"
          aria-label="Загрузка приложения"
          aria-valuemin={0}
          aria-valuemax={steps.length}
          aria-valuenow={done}
        >
          {steps.map((s) => (
            <span key={s.id} className={styles.segment}>
              <span className={cn(styles.fill, FILL[s.state])} />
            </span>
          ))}
        </div>

        { }
        <div className={styles.caption} key={text}>
          {text}
        </div>
      </div>
    </div>
  );
};
